import Graph from "../../models/graph";
import { ActiveItemType, RootState } from "../../types";
import { AnswerType } from "../../types/answers";

export const graphSelector = (state: RootState): Graph => state.graph.graph;

export const activeItemSelector = (state: RootState): ActiveItemType =>
  state.graph.activeItem;

export const showLinkDotsSelector = (state: RootState): boolean =>
  state.graph.showLinkDots;

export const showPropertiesSelector = (state: RootState): boolean =>
  state.graph.showProperties;

export const answersSelector = (state: RootState): AnswerType[] =>
  state.graph.answers;

export const distanceTypeSelector = (state: RootState): any =>
  state.graph.distanceType;
